import { EVENT_STATUSES, IEvent } from 'src/api/getEvents';

export const getMenuVenueCounts = (venues: IEvent[]) =>
  venues.reduce(
    (counts, venue) => {
      if (venue.status === EVENT_STATUSES.SUCCESS) counts.success += 1;
      else if (venue.status === EVENT_STATUSES.PENDING) counts.pending += 1;
      else if (venue.status === EVENT_STATUSES.FAILURE) counts.failure += 1;
      return counts;
    },
    { success: 0, pending: 0, failure: 0 },
  );
